import React from "react";
import { api } from "../../api/api";
import { useBillingCompanyContext } from "../../providers";
import { EnrAutoComplete } from "../basic/EnrAutoComplete";

export interface IActionItemCategoryOption {
  action_item_category_uuid?: string;
  category_code: string;
  category_name: string;
}

interface IProps {
  label?: string;
  value: { category_code?: string; category_name?: string };
  onSelect: (opt: IActionItemCategoryOption | null) => void;
  disabled?: boolean;
  placeholder?: string;
  error?: string;
}

export const ActionItemCategoryAutoSearch: React.FC<IProps> = ({
  value,
  onSelect,
  disabled,
  placeholder = "Select category",
  label = "Select category",
  error,
}) => {
  const companyOutlet = useBillingCompanyContext();
  const [options, setOptions] = React.useState<IActionItemCategoryOption[]>([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      try {
        const res = await api.get(
          `/conversation/get-action-item-category?company_outlet_uuid=${companyOutlet.comapny.company_outlet_uuid}&pageNo=1&itemPerPage=100&pageLimit=100&status=ACTIVE`,
        );
        if (!cancelled) setOptions(res.data?.data || []);
      } catch {
        if (!cancelled) setOptions([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [companyOutlet.comapny.company_outlet_uuid]);

  const matched = options.find(
    (o) =>
      o.category_code === value.category_code &&
      o.category_name === value.category_name,
  );
  const selected: IActionItemCategoryOption | null =
    matched ||
    (value.category_name
      ? {
          category_code: value.category_code || "",
          category_name: value.category_name,
        }
      : null);

  return (
    <EnrAutoComplete<IActionItemCategoryOption>
      fullWidth
      disabled={disabled}
      loading={loading}
      label={label}
      error={error}
      options={options}
      value={selected}
      getOptionLabel={(o) => o?.category_name || ""}
      getTagLabel={(o) => o?.category_name || ""}
      isOptionEqualToValue={(a, b) =>
        a.category_code === b.category_code &&
        a.category_name === b.category_name
      }
      onChange={(_, v) => onSelect(v as IActionItemCategoryOption | null)}
    />
  );
};
